import { heroStats } from "@/mocks/movies";

const heroCards = [
  { id: "h1", icon: "ri-play-circle-line", title: "在线观看", desc: "点开即播，不用装插件" },
  { id: "h2", icon: "ri-gift-line", title: "免费观看", desc: "片库浏览无需付费" },
  { id: "h3", icon: "ri-hd-line", title: "高清播放", desc: "蓝光起步，支持 4K" },
  { id: "h4", icon: "ri-flashlight-line", title: "极速观看", desc: "就近节点，秒开起播" },
  { id: "h5", icon: "ri-shield-check-line", title: "无广告", desc: "正片直入，不打断" },
  { id: "h6", icon: "ri-movie-2-line", title: "蓝光画质", desc: "HDR 层次更清楚" },
];

export default function Hero() {
  const jump = (id: string) => {
    const target = document.getElementById(id);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 68;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20abstract%20background%20with%20warm%20amber%20projector%20light%20beams%20crossing%20through%20soft%20haze%2C%20deep%20crimson%20curtain%20textures%20in%20the%20distance%2C%20delicate%20film%20grain%20atmosphere%2C%20moody%20premium%20streaming%20platform%20banner%2C%20no%20text%2C%20high%20contrast%20and%20mysterious%20elegant%20mood&width=1920&height=1080&seq=shenma-hero-main&orientation=landscape"
          alt="神马电影网 首页影院氛围背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 pb-14 md:pt-36 md:pb-20">
        <div className="max-w-content mx-auto">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 border border-background-50/25 text-background-100 text-xs md:text-sm backdrop-blur-sm">
              <i className="ri-fire-line text-accent-400"></i>
              在线观看 · 免费高清 · 极速无广告
            </span>
            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              神马电影网在线观看，
              <span className="text-accent-400">免费高清</span>一路到底
            </h1>
            <p className="mt-5 text-background-200 text-sm md:text-base leading-relaxed max-w-2xl">
              从片库浏览、清晰度选择到极速起播，这里把在线观看的每一步都讲清楚。影片、剧集、综艺与纪录片按题材与评分归类，蓝光与 4K 画质随网络自动匹配，正片中途不插广告，打开页面就能直接开看。
            </p>
          </div>

          <div className="mt-7 flex flex-col sm:flex-row gap-3 sm:items-center">
            <button
              type="button"
              onClick={() => jump("featured")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-base"></i>
              查看本周热映
            </button>
            <button
              type="button"
              onClick={() => jump("quality")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/12 border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors backdrop-blur-sm cursor-pointer whitespace-nowrap"
            >
              <i className="ri-hd-line text-base"></i>
              了解高清画质
            </button>
          </div>

          <div className="mt-9 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
            {heroCards.map((card) => (
              <div
                key={card.id}
                className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm p-4 hover:bg-background-50/16 transition-colors"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500/90 text-primary-950 mb-3">
                  <i className={`${card.icon} text-lg`}></i>
                </span>
                <h3 className="text-background-50 text-sm font-bold">{card.title}</h3>
                <p className="mt-1 text-background-300 text-xs leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-9 grid grid-cols-2 md:grid-cols-4 gap-px rounded-lg overflow-hidden border border-background-50/15 bg-background-50/10">
            {heroStats.map((stat) => (
              <div key={stat.id} className="bg-background-950/25 px-4 py-4 text-center backdrop-blur-sm">
                <p className="font-heading text-xl md:text-2xl font-bold text-accent-400">{stat.value}</p>
                <p className="mt-1 text-xs text-background-300">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}